export const getValidEnumValue = (lookup: object, value: number, defaultValue: number) => {
	if (Object.values(lookup).includes(value)) {
		return value
	} else {
		return defaultValue
	}
}
